import { SVGProps } from 'react';

const SvgExperiments = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 14" {...props}>
        <path d="M1.4 11.9a.7.7 0 0 0 .7.7h8.4a.7.7 0 0 0 .574-1.099L7 4.445V1.4H5.6v3.045l-4.074 7.056a.71.71 0 0 0-.126.399Zm.7 2.1A2.1 2.1 0 0 1 0 11.9c0-.42.126-.812.35-1.141L4.2 4.067V2.8a.7.7 0 0 1-.7-.7v-.7A1.4 1.4 0 0 1 4.9 0h2.8a1.4 1.4 0 0 1 1.4 1.4v.7a.7.7 0 0 1-.7.7v1.267l3.85 6.692c.224.329.35.721.35 1.141a2.1 2.1 0 0 1-2.1 2.1H2.1ZM7 9.8l.938-.938L9.289 11.2H3.311l1.862-3.227L7 9.8ZM6.65 7a.35.35 0 1 1 0 .7.35.35 0 0 1 0-.7Z" />
    </svg>
);
export default SvgExperiments;
